export type BulkCandidate = {
    rowNumber: number;
    name: string;
    email: string;
    mobile: string;
    college: string;
    branch: string;
    year: string;
    rollNumber: string;
    errors: string[];
};

export const candidateTemplateHeaders = ["Name", "Email", "Mobile", "College", "Branch", "Year", "Roll Number"];

const aliases: Record<string, keyof Omit<BulkCandidate, "rowNumber" | "errors">> = {
    name: "name", studentname: "name", fullname: "name",
    email: "email", emailid: "email", mailid: "email",
    mobile: "mobile", phone: "mobile", phonenumber: "mobile", mobilenumber: "mobile",
    college: "college", collegename: "college", institute: "college", institutename: "college",
    branch: "branch", course: "branch", coursename: "branch",
    year: "year", academicyear: "year",
    rollnumber: "rollNumber", rollno: "rollNumber", studentrollno: "rollNumber", studentid: "rollNumber",
};

function normalizeHeader(value: unknown) {
    return String(value ?? "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");
}

export function rowsToCandidates(rows: unknown[][]): BulkCandidate[] {
    if (rows.length < 2) return [];
    const mappedHeaders = rows[0].map((header) => aliases[normalizeHeader(header)] || null);
    const seenEmails = new Set<string>();
    return rows.slice(1).map((row, index) => {
        const values: Record<string, unknown> = {};
        mappedHeaders.forEach((field, columnIndex) => { if (field) values[field] = row[columnIndex]; });
        const candidate: BulkCandidate = {
            rowNumber: index + 2,
            name: String(values.name ?? "").trim(),
            email: String(values.email ?? "").trim().toLowerCase(),
            mobile: String(values.mobile ?? "").trim(),
            college: String(values.college ?? "").trim(),
            branch: String(values.branch ?? "").trim(),
            year: String(values.year ?? "").trim(),
            rollNumber: String(values.rollNumber ?? "").trim(),
            errors: [],
        };
        if (!candidate.name) candidate.errors.push("Student name is required");
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(candidate.email)) candidate.errors.push("Valid email is required");
        if (candidate.mobile && candidate.mobile.replace(/\D/g, "").length < 7) candidate.errors.push("Mobile number is invalid");
        if (candidate.email && seenEmails.has(candidate.email)) candidate.errors.push("Duplicate email in file");
        seenEmails.add(candidate.email);
        return candidate;
    }).filter((candidate) => Object.values(candidate).some((value) => typeof value === "string" && value.length > 0));
}

export function parseCsv(text: string): unknown[][] {
    const rows: string[][] = [];
    let row: string[] = [];
    let value = "";
    let quoted = false;
    for (let index = 0; index < text.length; index += 1) {
        const character = text[index];
        const next = text[index + 1];
        if (character === '"' && quoted && next === '"') { value += '"'; index += 1; }
        else if (character === '"') quoted = !quoted;
        else if (character === "," && !quoted) { row.push(value); value = ""; }
        else if ((character === "\n" || character === "\r") && !quoted) {
            if (character === "\r" && next === "\n") index += 1;
            row.push(value);
            if (row.some((cell) => cell.trim())) rows.push(row);
            row = [];
            value = "";
        } else value += character;
    }
    row.push(value);
    if (row.some((cell) => cell.trim())) rows.push(row);
    return rows;
}

export function candidateTemplateCsv() {
    return [
        candidateTemplateHeaders.join(","),
        "Ananya Rao,ananya@example.com,+919876543210,Example Engineering College,CSE,3,22CSE001",
        "Rahul Kumar,rahul@example.com,+919812345678,Example Engineering College,ECE,3,22ECE014",
    ].join("\n");
}
